module.exports = __webpack_public_path__ + "static/media/1_Dior Bellavita - Taipei.d8cc0961.jpg";